import { render, staticRenderFns } from "./PendingCJSO.vue?vue&type=template&id=212e63ca"
import script from "./PendingCJSO.vue?vue&type=script&lang=js"
export * from "./PendingCJSO.vue?vue&type=script&lang=js"
import style0 from "./PendingCJSO.vue?vue&type=style&index=0&id=212e63ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports